// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed.svelte-tjdjxm{position:fixed;top:0;left:0;height:100vh;width:100%;background-image:linear-gradient(var(--background-from), var(--background-to));z-index:-2}.canvas.svelte-tjdjxm{position:absolute;width:100%;z-index:-1;overflow:hidden}.canvas.topp.svelte-tjdjxm{top:0}.canvas.bunn.svelte-tjdjxm{bottom:0}", ""]);
// Exports
module.exports = exports;
